import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { Util } from '../../shared/util';
import { CustomValidator } from '../../shared/validators/custom.validator';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { Unidade } from '../../../models/unidade';
import { UnidadeService } from '../../shared/services/unidade.service';
import { ClinicaService } from '../clinica.service';
import { EnderecoService } from '../../shared/services/endereco.service';

@Component({
  templateUrl: './cadastro-clinica-form.component.html'
})
export class CadastroClinicaFormComponent extends WebPage implements OnInit {

  displayForm = false;
  isSubmitted = false;

  ufs;
  unidadesSelecionaveis;

  isCepDefinido = false;
  isCepRepresentanteDefinido = false;
  isCepAtendimentoDefinido = false;

  get locaisAtendimento() { return this.form.get('locaisAtendimento') as FormArray; }
  get unidadesSelecionadas() { return this.form.get('unidadesSelecionadas') as FormArray; }
  get idUfRazaoSocial() { return this.form.get('endereco').get('idUf'); }
  get cep() { return this.form.get('endereco').get('cep'); }
  get representanteCep() { return this.form.get('representante').get('endereco').get('cep'); }

  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private unidadeService: UnidadeService, private clinicaService: ClinicaService, private enderecoService: EnderecoService
  ) {
    super(messageService);

    this.form = fb.group({
      idClinica: [],
      hasExameAptidao: [false, Validators.required],
      hasAvaliacaoPsicologica: [false, Validators.required],
      hasToxicologico: [false, Validators.required],
      razaoSocial: [null, Validators.required],
      objetoSocial: [null, Validators.required],
      cnpj: [null, [Validators.required, CustomValidator.CNPJValidator]],
      email: [null, [Validators.required, CustomValidator.EmailValidator]],
      telefone: [null, [Validators.required, CustomValidator.TelefoneValidator]],
      endereco: fb.group({
        idEndereco: [],
        cep: [null, [Validators.required, CustomValidator.CepValidator]],
        logradouro: [null, Validators.required],
        complemento: [],
        bairro: [null, Validators.required],
        cidade: [null, Validators.required],
        idUf: [null, Validators.required]
      }),
      representante: fb.group({
        idRepresentante: [],
        nome: [null, Validators.required],
        cpf: [null, [Validators.required, CustomValidator.CpfValidator]],
        rg: [null, Validators.required],
        telefone: [null, [Validators.required, CustomValidator.TelefoneValidator]],
        nacionalidade: [null, Validators.required],
        naturalidade: [null, Validators.required],
        cargo: [null, Validators.required],
        endereco: fb.group({
          idEndereco: [],
          cep: [null, [Validators.required, CustomValidator.CepValidator]],
          logradouro: [null, Validators.required],
          complemento: [],
          bairro: [null, Validators.required],
          cidade: [null, Validators.required],
          idUf: [null, Validators.required]
        })
      }),
      locaisAtendimento: fb.array([]),
      unidadesSelecionadas: fb.array([])
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.unidadeService.getListaUf()
      .finally(() => this.isLoading = false)
      .subscribe(
        ufs => this.ufs = ufs,
        error => this.gerenciaErro(error)
      );
  }

  limpaCamposForm() {
    this.isSubmitted = false;
    this.isCepDefinido = false;
    this.isCepRepresentanteDefinido = false;
    this.isCepAtendimentoDefinido = false;

    this.form.patchValue({
      idClinica: null,
      hasExameAptidao: false,
      hasAvaliacaoPsicologica: false,
      objetoSocial: null,
      cnpj: null,
      email: null,
      telefone: null,
      endereco: {
        idEndereco: null,
        cep: null,
        logradouro: null,
        complemento: null,
        bairro: null,
        cidade: null,
        idUf: null,
      },
      representante: {
        idRepresentante: null,
        nome: null,
        cpf: null,
        rg: null,
        telefone: null,
        nacionalidade: null,
        naturalidade: null,
        cargo: null,
        endereco: {
          idEndereco: null,
          cep: null,
          logradouro: null,
          complemento: null,
          bairro: null,
          cidade: null,
          idUf: null,
        }
      },
    });
    this.locaisAtendimento.controls = [];
    this.unidadesSelecionadas.controls = [];

    this.unidadesSelecionaveis = [];
  }

  consultaCnpj(cnpj: string) {
    this.limpaCamposForm();

    const cnpjLimpo = Util.limpaCnpj(cnpj);

    if (!Util.isCnpj(cnpjLimpo)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Cnpj inválido!' });
      return;
    }

    this.isLoading = true;
    this.clinicaService.getByCnpj(cnpjLimpo)
      .finally(() => this.isLoading = false)
      .subscribe(
        clinica => {
          this.form.patchValue({
            cnpj: cnpj
          });

          if (clinica === null) {
            // this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'CNPJ não encontrado!'});
            return;
          }

          this.form.patchValue({
            idClinica: clinica.idClinica,
            hasExameAptidao: clinica.hasExameAptidao,
            hasAvaliacaoPsicologica: clinica.hasAvaliacaoPsicologica,
            razaoSocial: clinica.razaoSocial,
            objetoSocial: clinica.objetoSocial,
            email: clinica.email,
            telefone: clinica.telefone,
            endereco: {
              idEndereco: clinica.endereco.idEndereco,
              cep: clinica.endereco.cep,
              logradouro: clinica.endereco.logradouro,
              complemento: clinica.endereco.complemento,
              bairro: clinica.endereco.bairro,
              cidade: clinica.endereco.cidade,
              idUf: clinica.endereco.idUf
            },
            representante: {
              idRepresentante: clinica.representante.idRepresentante,
              nome: clinica.representante.nome,
              cpf: clinica.representante.cpf,
              rg: clinica.representante.rg,
              telefone: clinica.representante.telefone,
              nacionalidade: clinica.representante.nacionalidade,
              naturalidade: clinica.representante.naturalidade,
              cargo: clinica.representante.cargo,
              endereco: {
                idEndereco: clinica.representante.endereco.idEndereco,
                cep: clinica.representante.endereco.cep,
                logradouro: clinica.representante.endereco.logradouro,
                complemento: clinica.representante.endereco.complemento,
                bairro: clinica.representante.endereco.bairro,
                cidade: clinica.representante.endereco.cidade,
                idUf: clinica.representante.endereco.idUf
              }
            }
          });

          this.locaisAtendimento.controls = [];
          clinica.locaisAtendimento.forEach(localAtendimento => {
            this.adicionarLocalAtendimento(
              localAtendimento.idLocalAtendimento,
              localAtendimento.descricao,
              localAtendimento.nomeResponsavel,
              localAtendimento.endereco.cep,
              localAtendimento.endereco.logradouro,
              localAtendimento.endereco.complemento,
              localAtendimento.endereco.bairro,
              localAtendimento.endereco.idUf,
              localAtendimento.endereco.uf.siglaUf,
              localAtendimento.endereco.cidade,
              localAtendimento.telefone
            );
          });

          this.unidadesSelecionadas.controls = [];
          clinica.clinicaUnidades.forEach(clinicaUnidade => {
            const unidade = clinicaUnidade.unidade;
            const nomeUnidade = unidade.tipologia + ' - ' + unidade.nomeUnidade + '/' + unidade.uf.siglaUf;
            this.adicionarUnidade(clinicaUnidade.idClinicaUnidade, clinicaUnidade.idUnidade, nomeUnidade);
          });

          // this.carregarUnidades(this.idUfRazaoSocial.value);
        },
        error => this.gerenciaErro(error)
      );

    this.displayForm = true;
  }

  getEnderecoByCep(uf) {
    this.isCepDefinido = false;

    this.form.patchValue({
      endereco: {
        logradouro: null,
        complemento: null,
        bairro: null,
        idUf: null,
        cidade: null
      }
    });

    const cep = this.cep.value;
    if (Util.isNullOrEmptyOrUndefined(cep) || cep.length < 3) {
      return;
    }

    this.isLoading = true;
    this.enderecoService.getEnderecoByCep(Util.limpaCep(cep))
      .finally(() => this.isLoading = false)
      .subscribe (
        endereco => {
          if (Util.isNullOrEmptyOrUndefined(endereco)) {
            this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Endereço não encontrado' });
            return;
          }

          this.form.patchValue({
            endereco: {
              cidade: endereco.cidade,
              logradouro: endereco.logradouro,
              bairro: endereco.bairro,
              idUf: endereco.idUf
            }
          });

          this.isCepDefinido = true;

          this.carregarUnidades(endereco.idUf);
        },
        error => this.gerenciaErro(error)
      );
  }

  getEnderecoByRepresentanteCep() {
    this.isCepRepresentanteDefinido = false;

    this.form.patchValue({
      representante: {
        endereco: {
          logradouro: null,
          complemento: null,
          bairro: null,
          idUf: null,
          cidade: null
        }
      }
    });

    const cep = this.representanteCep.value;
    if (Util.isNullOrEmptyOrUndefined(cep) || cep.length < 3) {
      return;
    }

    this.isLoading = true;
    this.enderecoService.getEnderecoByCep(Util.limpaCep(cep))
      .finally(() => this.isLoading = false)
      .subscribe (
        endereco => {
          if (Util.isNullOrEmptyOrUndefined(endereco)) {
            this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Endereço não encontrado' });
            return;
          }

          this.form.patchValue({
            representante: {
              endereco: {
                cidade: endereco.cidade,
                logradouro: endereco.logradouro,
                bairro: endereco.bairro,
                idUf: endereco.idUf
              }
            }
          });

          this.isCepRepresentanteDefinido = true;
        },
        error => this.gerenciaErro(error)
      );
  }

  getEnderecoByAtendimentoCep(
    cepAtendimento, logradouroAtendimento, complementoAtendimento, bairroAtendimento, ufAtendimento, cidadeAtendimento
  ) {
    this.isCepAtendimentoDefinido = false;

    logradouroAtendimento.value =  null;
    complementoAtendimento.value =  null;
    bairroAtendimento.value =  null;
    ufAtendimento.selectedIndex = 0;
    cidadeAtendimento.value =  null;

    const cep = cepAtendimento.value;
    if (Util.isNullOrEmptyOrUndefined(cep) || cep.length < 3) {
      return;
    }

    this.isLoading = true;
    this.enderecoService.getEnderecoByCep(Util.limpaCep(cep))
      .finally(() => this.isLoading = false)
      .subscribe (
        endereco => {
          if (Util.isNullOrEmptyOrUndefined(endereco)) {
            this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Endereço não encontrado' });
            return;
          }

          logradouroAtendimento.value =  endereco.logradouro;
          bairroAtendimento.value =  endereco.bairro;
          ufAtendimento.value = endereco.idUf;
          cidadeAtendimento.value =  endereco.cidade;

          this.isCepAtendimentoDefinido = true;
        },
        error => this.gerenciaErro(error)
      );
  }

  carregarUnidades(idUf) {
    if (idUf === '') {
      this.unidadesSelecionaveis = [];
      return;
    }

    this.isLoading = true;
    this.unidadeService.getUnidadesComEditalClinicaByIdUf(idUf)
      .finally(() => this.isLoading = false)
      .subscribe(
        unidades => {
          this.unidadesSelecionaveis = unidades;
          console.log('Unidade');
          console.log(unidades);

          this.unidadesSelecionadas.controls.forEach(us => {
            this.removeUnidadeDosSelecionaveis(us);
          });
        },
        error => this.gerenciaErro(error)
      );
  }

  // ------
  // Local de Atendimento
  enviaLocalAtendimento (
    descricaoAtendimento: HTMLInputElement,
    nomeResponsavelAtendimento: HTMLInputElement,
    cepAtendimento: HTMLInputElement,
    logradouroAtendimento: HTMLInputElement,
    complementoAtendimento: HTMLInputElement,
    bairroAtendimento: HTMLInputElement,
    ufAtendimento: HTMLSelectElement,
    cidadeAtendimento: HTMLInputElement,
    telefoneAtendimento: HTMLInputElement
  ) {
    if (!this.validaLocalAtendimento(
      descricaoAtendimento.value, nomeResponsavelAtendimento.value,
      cepAtendimento.value, logradouroAtendimento.value, complementoAtendimento.value, bairroAtendimento.value,
      ufAtendimento[ufAtendimento.selectedIndex].value, cidadeAtendimento.value, telefoneAtendimento.value
    )) {
      return;
    }

    this.adicionarLocalAtendimento (
      null,
      descricaoAtendimento.value, nomeResponsavelAtendimento.value,
      cepAtendimento.value, logradouroAtendimento.value, complementoAtendimento.value, bairroAtendimento.value,
      ufAtendimento[ufAtendimento.selectedIndex].value, ufAtendimento[ufAtendimento.selectedIndex].textContent,
      cidadeAtendimento.value, telefoneAtendimento.value
    );

    descricaoAtendimento.value = '';
    nomeResponsavelAtendimento.value = '';
    cepAtendimento.value = '';
    logradouroAtendimento.value = '';
    complementoAtendimento.value = '';
    bairroAtendimento.value = '';
    ufAtendimento.selectedIndex = 0;
    cidadeAtendimento.value = '';
    telefoneAtendimento.value = '';

    this.isCepAtendimentoDefinido = false;
  }

  // TODO localAtendimento tinha que ser um form
  validaLocalAtendimento(descricao, nomeResponsavel, cep, logradouro, complemento, bairro, idUf, cidade, telefone) {
    if (Util.isNullOrEmptyOrUndefined(descricao)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Descrição inválida!' });
      return false;
    }
    if (Util.isNullOrEmptyOrUndefined(nomeResponsavel)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Nome do Responsável inválido!' });
      return false;
    }
    if (!Util.isCep(cep)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'CEP inválido!' });
      return false;
    }
    if (Util.isNullOrEmptyOrUndefined(logradouro)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Logradouro inválido!' });
      return false;
    }
    if (Util.isNullOrEmptyOrUndefined(bairro)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Bairro inválido!' });
      return false;
    }
    if (Util.isNullOrEmptyOrUndefined(idUf)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'UF inválido!' });
      return false;
    }
    if (Util.isNullOrEmptyOrUndefined(cidade)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Cidade inválida!' });
      return false;
    }
    if (!Util.isTelefone(telefone)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Telefone inválido!' });
      return false;
    }
    return true;
  }

  adicionarLocalAtendimento(
    idLocalAtendimento, descricao, nomeResponsavel,
    cep, logradouro, complemento, bairro, idUf, uf, cidade, telefone
  ) {
    const localAtendimentoFormGroup = this.fb.group({
      idLocalAtendimenot: idLocalAtendimento,
      descricao: descricao,
      nomeResponsavel: nomeResponsavel,
      endereco: this.fb.group({
        cep: [cep, Validators.required],
        logradouro: [logradouro, Validators.required],
        complemento: complemento,
        bairro: [bairro, Validators.required],
        idUf: [idUf, Validators.required],
        uf: [uf, Validators.required],
        cidade: [cidade, Validators.required],
      }),
      telefone: [telefone, Validators.required]
    });
    this.locaisAtendimento.push(localAtendimentoFormGroup);
  }

  removeLocalAtendimento(localAtendimento) {
    const index = this.locaisAtendimento.controls.indexOf(localAtendimento);
    this.locaisAtendimento.removeAt(index);
  }
  // Local de Atendimento
  // ------

  // ------
  // Unidade
  enviaUnidade(unidadeSelecionada: HTMLSelectElement) {
    const unidade = unidadeSelecionada[unidadeSelecionada.selectedIndex];

    if (Util.isNullOrEmptyOrUndefined(unidade.value)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione uma Unidade!' });
      return;
    }

    this.adicionarUnidade(null, unidade.value, unidade.textContent);
    unidadeSelecionada.selectedIndex = 0;
  }

  adicionarUnidade(idClinicaUnidade, idUnidade, nomeUnidade) {
    const unidadeFormGroup = this.fb.group({
      idClinicaUnidade: idClinicaUnidade,
      idUnidade: idUnidade,
      nomeUnidade: [nomeUnidade, Validators.required]
    });
    this.unidadesSelecionadas.push(unidadeFormGroup);

    this.removeUnidadeDosSelecionaveis(unidadeFormGroup);
  }

  removeUnidadeDosSelecionaveis(unidadeSelecionada) {
    const indexARemover = this.unidadesSelecionaveis.findIndex(u => u.idUnidade === unidadeSelecionada.value.idUnidade);
    if (indexARemover !== -1) {
      this.unidadesSelecionaveis.splice(indexARemover, 1);
    }
  }

  removeUnidadeSelecionada(unidadeSelecionada: FormGroup) {
    const index = this.unidadesSelecionadas.controls.indexOf(unidadeSelecionada);
    this.unidadesSelecionadas.removeAt(index);

    this.carregarUnidades(this.idUfRazaoSocial.value);
  }
  // Unidade
  // ------

  submit() {
    this.isSubmitted = true;

    if (!this.validaForm()) {
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja confirmar os dados digitados?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.clinicaService.cadastrarEditar(this.form.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              localStorage.setItem(
                'mensagem',
                `Cadastro salvo com sucesso!
                É necessário imprimir, assinar, reconhecer firma
                e entregar na Unidade Operacional do SEST SENAT o requerimento para credenciamento.
                Este documento pode ser gerado através da opção “Gerar Requerimento”.`
              );
              console.log('toxicologico:', this.form.value)
              this.router.navigate(['/visualizar-editais-clinica']);
            },
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  validaForm(): boolean {
    if (this.locaisAtendimento.length <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: `É necessário adicionar ao menos um local de atendimento,
          mesmo que o endereço seja idêntico ao já informado na seção “Identificação” no ínicio desta página!`
      });
      return false;
    }

    if (this.unidadesSelecionadas.length <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção', detail: 'É necessário adicionar ao menos uma Unidade Operacional!'
      });
      return false;
    }

    const control = this.locaisAtendimento.controls.find(la => la.get('endereco').get('idUf').value !== this.idUfRazaoSocial.value);
    if (control !== undefined && control !== null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'O CEP do local de atendimento deve ser da mesma da UF do endereço da razão social da Clínica!'
      });
      return false;
    }

    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Formulário preenchido incorretamente.' });
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/clinica/cadastro-clinica-form/cadastro-clinica-form.component.ts